
/*************************
 * in a div, make a <custom-select></custom-select> , with <option></option> inside
 * the custom-select will be converted into a custom dropdown
 * 
*************************/

function initCustomDropdowns(el) {
  var j, ll, selElmnt, a, b, c;
  /* Look for any elements with the class "custom-select": */
  const thisCustomSelect = el;
  selElmnt = thisCustomSelect.getElementsByTagName("select")[0];
  ll = selElmnt.length;

  let isSortSelector = false;
  let isColorSelector = false;
  switch (thisCustomSelect.getAttribute("name")) {
    case "sort_by":
      isSortSelector = true;
      break;
    case "color":
      isColorSelector = true;
      break;
    default:
      isColorSelector = false;
      isSortSelector = false;
      break;
  }
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  if (thisCustomSelect.hasAttribute("select-text")) {
    a.textContent = thisCustomSelect.getAttribute("select-text");
  }

  thisCustomSelect.appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("custom-option");
    if (isColorSelector) {
      c.innerHTML = `<div class='color-swatch'></div>` + selElmnt.options[j].innerHTML;
      c.setAttribute("data-color", selElmnt.options[j].innerHTML.toLowerCase().split(" ").join("-"));
    } else {
      c.innerHTML = `<div>` + selElmnt.options[j].innerHTML + `</div>`;
    }

    if (selElmnt.options[j]?.selected) {
      c.setAttribute("class", "same-as-selected")
    }

    c.addEventListener("click", function (e) {
      /* When an item is clicked, update the original select box,
      and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML.includes(this.textContent)) {
          s.selectedIndex = i;

          if (!isSortSelector) {
            h.innerHTML = this.innerHTML;
            h.parentNode.setAttribute("value", this.textContent);
            h.setAttribute("data-color", this.getAttribute("data-color"));
          }



          if (isSortSelector) {
            s.dispatchEvent(new Event('change'));
            s.onchange();
            if ("createEvent" in document) {
              var evt = document.createEvent("HTMLEvents");
              evt.initEvent("change", false, true);
              s.dispatchEvent(evt);
            }
            else {
              s.fireEvent("onchange");
            }
          }

          y = this.parentNode.getElementsByClassName("same-as-selected");
          this.parentNode.parentNode.removeAttribute("open");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    }, true);
    b.appendChild(c);
  }
  thisCustomSelect.appendChild(b);
}

class CustomSelector extends HTMLElement {
  constructor(node) {
    super();
    this.props();
    this.init();
  }

  get value() {
    return this.getAttribute("value");
  }

  set value(value) {
    this.setAttribute("value", value);
  }

  set options(options) { }
  get options() {
    return this.querySelectorAll("custom-option");
  }

  init() {
    this.generate();
    document.addEventListener("click", (e) => {
      e.stopPropagation();
      this.closeAll();
      this.close();
    });
    this.addEventListener("click", (e) => {
      e.stopPropagation();
      this.closeAll();
      this.toggle();
    });
    this.inited = true;
  }

  generate() {
    initCustomDropdowns(this);
  }

  props() {
    this.open = false;
    this.inited = false;
    this.type = this.querySelector("[data-type]").getAttribute("data-type");
  }

  toggle() {
    if (this.hasAttribute("open")) this.removeAttribute("open");
    else this.setAttribute("open", '');
  }

  close() {
    this.removeAttribute("open");
  }

  closeAll() {
    document.querySelectorAll('custom-select')?.forEach(sel => {
      sel != this && sel.close();
    });
  }
}

customElements.define('custom-select', CustomSelector);

